export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const API_URL = config.public.apiUrl;

  const cloudflareTurnstile = async (token: string): Promise<boolean> => {
    try {
      const response: Response = await fetch(`${API_URL}/cfturnstile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data: string = await response.json();
      return data === 'success';
    } catch (error) {
      console.error('Error verifying token:', error);
      return false;
    }
  };

  return {
    provide: {
      functions: { cloudflareTurnstile },
    },
  };
});